module.exports = __webpack_public_path__ + "img/owl.video.play.4a37f800.png";